import React from 'react';
import { Box, Chip, Tooltip, Typography } from '@mui/material';

export default function GetMoodGenreLanguage({ icon, label, items, sliceCount }) {
  // Check if the items are objects and map them to their labels
  const processedItems = Array.isArray(items) && items.length > 0
    ? (typeof items[0] === 'object' && items[0]?.platformName
      ? items.map((item) => item.platformName)
      : items)
    : [];

  const displayedItems = processedItems.slice(0, sliceCount);
  const remainingItems = processedItems.length > sliceCount
    ? processedItems.slice(sliceCount)
    : [];


  return (
    <Box className='d-flex align-items-baseline gap-2'>
      <Typography variant="body2"><strong>{label}</strong></Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, marginTop: 1 }}>
        {/* Render displayed items */}
        {displayedItems.map((item, index) => (
          <Chip
            icon={icon}
            key={index}
            label={item}
            sx={{ backgroundColor: '#E6EEEF', fontSize: "12px" }}
          />
        ))}

        {/* Render remaining items as a tooltip */}
        {remainingItems.length > 0 && (
          <Tooltip
            title={remainingItems.join(', ')}
            placement="top"
            arrow
          >
            <Chip
              label={`+${remainingItems.length}`}
              sx={{ backgroundColor: '#E6EEEF', cursor: 'pointer', fontWeight: 'bold' }}
            />
          </Tooltip>
        )}
      </Box>
    </Box>
  );
}
